export default {
  name: 'marking--descRestH',
  apiService: 'shoes',
  apiPath: '/admin/desc_rest_h',
};